'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FlickityPreviousDirective = FlickityPreviousDirective;

var _previous = require('./previous.controller');

function FlickityPreviousDirective($log, $timeout, $rootScope, FlickityConfig, FlickityService) {
    'ngInject';

    var directive = {
        restrict: 'A',
        scope: {},
        bindToController: {
            bcFlickityPrevious: '=?',
            bcFlickityId: '@?'
        },
        compile: function compile() {
            return {
                pre: preLinkFunction
            };
        },
        controller: _previous.PreviousController,
        controllerAs: 'vm'
    };

    return directive;

    /**
     * Pre Link
     */
    function preLinkFunction($scope, $element, $attrs, $controller) {
        'ngInject';

        // Get the ID

        var ID = $controller.flickityId;

        // Define the broadcast names to listen for
        var selectEvent = 'Flickity:' + ID + ':cellSelect';
        var settleEvent = 'Flickity:' + $controller.flickityId + ':settle';

        // Listen
        var cellSelect = $rootScope.$on(selectEvent, function (event, data) {
            _disableButtonIfNeeded(data.instance.selectedIndex);
        });
        var settle = $rootScope.$on(settleEvent, function (event, data) {
            _disableButtonIfNeeded(data.instance.selectedIndex);
        });

        $element.on('click', function () {

            // Move to the next cell
            FlickityService.previous($controller.flickityId, $controller.wrapAround);
        });

        /**
         * Disable button if needed
         *
         * @param {Int} index
         */
        function _disableButtonIfNeeded(index) {
            // Disable button if at the beginning and we shouldn't wrap
            if (!$controller.wrapAround && index === 0) {
                $attrs.$set('disabled', 'disabled');
            } else {
                $attrs.$set('disabled', false);
            }
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/previous/flickityPrevious.directive.js
 **/